<template>
  <div class="border-white">
    <div class="col-1">
      <h3 class="sous-section">Justification</h3>
    </div>
    <div class="row">
      <div class="row">
        <div class="col-2 lbl"><label>Justification :</label></div>
        <div class="col-6">
          <TextArea v-model="justification.justificationText" rows="5" cols="142"/>
        </div>
      </div>
      <div>
        <AuditPiecesJointes ref="auditPiecesJointes"/>
      </div>
    </div>
  </div>
</template>
<script>

import AuditPiecesJointes from '@/components/pilotage/intervenant/Consulter/AuditPiecesJointes.vue'

export default {
  name: "InformationJustification",
  components: {
    AuditPiecesJointes,
  },
  mounted() {
  },
  methods: {
    getJustification() {
      this.justification.justificationFichier = this.$refs.auditPiecesJointes.getJustificationFichier();
      return this.justification
    },
    clearJustification() {
      this.justification.justificationText = null;
      this.$refs.auditPiecesJointes.clearJustification();
    }
  },
  data() {
    return {
      justification: {justificationText: null, justificationFichier: []}
    };
  },
}
</script>
